import { render, staticRenderFns } from "./MissingDataText.vue?vue&type=template&id=34728591&functional=true&"
import script from "./MissingDataText.vue?vue&type=script&lang=ts&"
export * from "./MissingDataText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports